export const STYLE_MAP = {
  default: {
    buttonSize: 30,
    trackHeight: 40,
    marqueeBgColor: '#fff',
    marqueeTextColor: '#333'
  },
  colmo: {
    buttonSize: 40,
    trackHeight: 64,
    marqueeBgColor: 'transparent',
    marqueeTextColor: 'rgba(255,255,255,0.80)'
  }
}



// WEBPACK FOOTER //
// ./packages/dof-music-player/style.js